export default __webpack_public_path__ + "warning-icon.3123c0a6648ebe9edf42921251b88134.svg";